'use strict';

var $ = require('jquery');

$(document).ready(function(){
    //svg for IE fix
    svg4everybody();
});